import React, { useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function Home() {
  useEffect(() => {
    const slides = document.querySelectorAll(".gmf-slide");
    const nextBtn = document.querySelector(".gmf-slider-btn.next");
    const prevBtn = document.querySelector(".gmf-slider-btn.prev");

    if (!slides.length) return;

    let currentSlide = 0;

    const showSlide = (index) => {
      slides.forEach((slide) => slide.classList.remove("active"));
      slides[index].classList.add("active");
    };

    const nextSlide = () => {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    };

    const prevSlide = () => {
      currentSlide = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(currentSlide);
    };

    nextBtn?.addEventListener("click", nextSlide);
    prevBtn?.addEventListener("click", prevSlide);

    const interval = setInterval(nextSlide, 5000);

    return () => {
      clearInterval(interval);
      nextBtn?.removeEventListener("click", nextSlide);
      prevBtn?.removeEventListener("click", prevSlide);
    };
  }, []);

  return (
    <>
      <Header />
      <div>
        {/* =========================
     GMF IMAGE SLIDER START
========================= */}
        <section className="gmf-slider-section">
          <div className="gmf-slider-container">
            <div className="gmf-slider">
              {/* 20 Slides */}
              <div className="gmf-slide active">
                <img src="/img/slider/slider1.png" alt="Slider 1" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider2.jpg" alt="Slider 2" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider3.jpg" alt="GMF Slide 3" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider4.jpg" alt="GMF Slide 4" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider5.jpg" alt="GMF Slide 5" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider6.jpg" alt="GMF Slide 6" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider7.jpg" alt="GMF Slide 7" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider8.jpg" alt="GMF Slide 8" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider9.jpg" alt="GMF Slide 9" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider10.jpg" alt="GMF Slide 10" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider11.png" alt="GMF Slide 11" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider12.jpg" alt="GMF Slide 12" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider13.png" alt="GMF Slide 13" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider14.jpg" alt="GMF Slide 14" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider15.jpg" alt="GMF Slide 15" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider16.jpg" alt="GMF Slide 16" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider17.jpg" alt="GMF Slide 17" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider18.jpg" alt="GMF Slide 18" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider19.png" alt="GMF Slide 19" />
              </div>
              <div className="gmf-slide">
                <img src="/img/slider/slider20.jpg" alt="GMF Slide 20" />
              </div>
            </div>
            {/* Navigation Buttons */}
            <button className="gmf-slider-btn prev">
              <i className="fa-solid fa-chevron-left"></i>
            </button>

            <button className="gmf-slider-btn next">
              <i className="fa-solid fa-chevron-right"></i>
            </button>
            {/* Dots */}
          </div>
        </section>
        {/* =========================
     GMF IMAGE SLIDER END
========================= */}
        {/* =========================
     GMF About
========================= */}
        <section className="about-gmf">
          <div className="about-left">
            <img
              src="img/logo/gandhimandelafoundation-about.png"
              alt="GMF Medal"
            />
          </div>
          <div className="about-right">
            <h2>GANDHI MANDELA FOUNDATION</h2>
            <p>
              The Gandhi Mandela Foundation (GMF) is a Government of
              India-recognized trust, established to promote the timeless
              values, ideals, and principles of Mahatma Gandhi and Nelson
              Mandela, fostering global peace, non-violence, individual freedom,
              civil liberties, and human rights.
            </p>
            <p>
              Headquartered in New Delhi, India, the Foundation has a strong and
              expanding global presence across more than 20 countries, including
              India, Nepal, United Kingdom, Ukraine, Malaysia, South Africa,
              Bangladesh, United States of America, Canada, Bolivia, Mexico, Sri
              Lanka, Russia, Australia, Spain, Colombia, Panama, Brazil,
              Argentina, Cuba, Venezuela, Costa Rica, Italy, Dominican Republic,
              and Madagascar.
            </p>
            <p>
              The Foundation has had the privilege of organizing prestigious
              international initiatives in collaboration with United Nations
              agencies, as well as embassies and high commissions across the
              world.
            </p>
            <a href="/about-gmf" className="about-btn">
              View More
            </a>
          </div>
        </section>
        {/* =========================
     GMF About  END
========================= */}
        {/* =========================
     BOARD MEMBERS
========================= */}
        <section className="board-members">
          <div className="container">
            <h2 className="section-title">BOARD MEMBERS</h2>
            <div className="members-grid">
              <div className="member-card">
                <div className="member-img">
                  <img src="img/members/Nandanji.jpg" alt="ADV. NANDAN JHA" />
                </div>
                <h3>ADV. NANDAN JHA</h3>
                <span>SECRETARY GENERAL</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/Acharya-Lokesh-Muni.jpg"
                    alt="ACHARYA LOKESH MUNI"
                  />
                </div>
                <h3>ACHARYA LOKESH MUNI</h3>
                <span>VICE CHAIRMAN</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/savita-singh.jpg"
                    alt="DR. SAVITA SINGH"
                  />
                </div>
                <h3>DR. SAVITA SINGH</h3>
                <span>VICE PRESIDENT</span>
              </div>
            </div>
          </div>
        </section>
        {/* =========================
     BOARD MEMBERS END
========================= */}
        {/* =========================
     JURY MEMBERS
========================= */}
        <section className="jury-members">
          <div className="container">
            <h2 className="section-title">JURY MEMBERS</h2>
            <div className="members-grid">
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/K.G.-BALAKRISHNAN.jpg"
                    alt="JUSTICE K.G. BALAKRISHNAN"
                  />
                </div>
                <h3>JUSTICE K.G. BALAKRISHNAN</h3>
                <span>
                  (FORMER CHIEF JUSTICE OF INDIA &amp; FORMER CHAIRMAN NHRC
                  INDIA)
                </span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/norma-lucia-pina.jpg"
                    alt="norma-lucia-pina"
                  />
                </div>
                <h3>NORMA LUCÍA PIÑA HERNÁNDEZ</h3>
                <span>(FORMER CHIEF JUSTICE OF THE MEXICAN SUPREME COURT)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/JUSTICE-DIPAK-MISRA.jpg"
                    alt="JUSTICE DIPAK MISRA"
                  />
                </div>
                <h3>JUSTICE DIPAK MISRA</h3>
                <span>(FORMER CHIEF JUSTICE OF INDIA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/KEDARNATH-UPADHYAY.jpg"
                    alt="KEDARNATH-UPADHYAY"
                  />
                </div>
                <h3>KEDARNATH-UPADHYAY</h3>
                <span>
                  (FORMER CHIEF JUSTICE OF NEPAL &amp; FORMER CHAIRMAN NHRC
                  NEPAL)
                </span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/RIGOBERTA.png"
                    alt="RIGOBERTA MENCHÚ TUM"
                  />
                </div>
                <h5
                  style={{
                    marginTop: "10px",
                    marginBottom: "-12px",
                  }}
                >
                  Nobel Peace Prize Winner - 1992
                </h5>
                <h3>RIGOBERTA MENCHÚ TUM</h3>
                <span>(Guatemalan Human Rights Activist)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/GYAN-SUDHA-MISRA.jpg"
                    alt="GYAN-SUDHA-MISRA"
                  />
                </div>
                <h3>JUSTICE GYAN SUDHA MISRA</h3>
                <span>(FORMER JUDGE SUPREME COURT OF INDIA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/MD-TAFAZZUL-ISLAM.jpg"
                    alt="MD TAFazzul Islam"
                  />
                </div>
                <h3>JUSTICE MD TAFAZZUL ISLAM</h3>
                <span>(FORMER CHIEF JUSTICE OF BANGLADESH)</span>
              </div>
            </div>
          </div>
        </section>
        {/* =========================
     JURY MEMBERS END
========================= */}
        {/* =========================
     INTERNATIONAL TEAM
========================= */}
        <section className="international-team">
          <div className="container">
            <h2 className="section-title">INTERNATIONAL TEAM</h2>
            <div className="members-grid">
              <div className="member-card">
                <div className="member-img">
                  <img src="img/members/indra.jpg" alt="INDRA P. KATTEL" />
                </div>
                <h3>INDRA P. KATTEL</h3>
                <span>(JT.DIRECTOR-INTERNATIONAL RELATIONS)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/DR.-MANUEL-GRANADOS-COVARRUBIAS.jpg"
                    alt="DR. MANUEL GRANADOS COVARRUBIAS"
                  />
                </div>
                <h3>DR. MANUEL GRANADOS COVARRUBIAS</h3>
                <span>(PRESIDENT, MEXICO)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/Stephen-Murray.jpg"
                    alt="STEPHEN MURRAY"
                  />
                </div>
                <h3>STEPHEN MURRAY</h3>
                <span>(PRESIDENT, LATIN AMERICA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/Jose-Raul-Vaquero-Pulido.jpg"
                    alt="JOSÉ RAÚL VAQUERO PULIDO"
                  />
                </div>
                <h3>JOSÉ RAÚL VAQUERO PULIDO</h3>
                <span>(PRESIDENT, SPAIN)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/agus-indra-udayana.jpg"
                    alt="AGUS INDRA UDAYANA"
                  />
                </div>
                <h3>AGUS INDRA UDAYANA</h3>
                <span>(PADMA SHRI, PRESIDENT, INDONESIA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img src="img/members/fransisco.jpeg" alt="FRANCISCO REYES" />
                </div>
                <h3>FRANCISCO REYES</h3>
                <span>(PRESIDENT, ITALY)</span>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
